import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { InvitedUserList } from './InvitedUserList';

export const InvitedUserModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.inviteType === 'CREATERINVITE' ? 'Creator Invited User List' : 'Invited User List'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InvitedUserList
          referralCode={props.referralCode}
          inviteType={props.inviteType}
          enabled={props.show && !!props.referralCode}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
